import React from 'react';
import styles from './index.module.less';
import { getLoginPath, getOfficialSitePath, getSignupPath } from '@/utils/function/sitePath';
import { ReoIcon } from '@reolink-web/components.basic';
import { HeaderContext } from '@/components/ReolinkHeader/common';
import classNames from 'classnames';

interface ICompAccountNavItemProps {
    className?: string;
}

const CompAccountNavItem: React.FC<ICompAccountNavItemProps> = (props) => {
    const { userPrefile, getTextByKey } = React.useContext(HeaderContext);

    const isLogin = !!userPrefile?.email;

    return (
        <li className={ classNames(styles['account-nav-item'], props.className) }>
            <div className={ styles['account-nav-item-content'] }>
                <ReoIcon
                    name={ 'icon-new_user' }
                    className={ styles['account-nav-item-icon'] } />
                <div className={ styles['account-nav-item-links'] }>
                    {isLogin ? (
                        <a
                            className={ styles['account-nav-item-link'] }
                            href={ getOfficialSitePath('/my-account/') }>
                            {getTextByKey('menu-dashboard')}
                        </a>
                    ) : (
                        <>
                            <a
                                className={ styles['account-nav-item-link'] }
                                href={ getLoginPath() }>
                                {getTextByKey('menu-log-in')}
                            </a>
                            <div className={ styles['account-nav-item-link-deliver'] }>|</div>
                            <a
                                className={ styles['account-nav-item-link'] }
                                href={ getSignupPath() }>
                                {getTextByKey('menu-sign-up')}
                            </a>
                        </>
                    )}
                </div>
            </div>
        </li>
    );
};
export default CompAccountNavItem;
